<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>供应点管理</el-breadcrumb-item>
        <el-breadcrumb-item>供应点综合管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="供应点名称：">
              <el-input size="small" v-model="listParams.name" placeholder="请输入供应点名称"> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="title" align="center" label="供应点名称"> </el-table-column>

        <el-table-column prop="address" align="center" label="供应点地址"> </el-table-column>
        <el-table-column prop="contactName" align="center" label="提货人"> </el-table-column>
        <el-table-column prop="contactMobile" align="center" label="提货人地址"> </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
      <Dialog :dialogTitle="dialogTitle" :supplyId="supplyId" :dialogVisible.sync="dialogVisible" :url="url" @reload="loadTableData" />
    </hx-table-result>
  </div>
</template>

<script>
import Dialog from "./components/Dialog.vue";
export default {
  components: { Dialog },
  data() {
    return {
      listParams: {
        supplyId: "",
        name: "",
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "",
      dialogVisible: false,
      url: "",
      method: "",
      itemParams: {
        supplyId: "",
        title: "",
        address: "",
      },
      supplyId: "",
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.loadTableData();
  },
  methods: {
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/logistics/index",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
          name: this.listParams.name,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增分类管理
     */
    toCreate() {
      this.dialogVisible = true;
      this.dialogTitle = "新增供应点";
      this.url = "/logistics/insert";
      this.supplyId = "";
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 修改条目数据
     * @param row
     */
    editItem(row) {
      this.dialogTitle = "编辑供应点";
      this.supplyId = row.id;
      this.dialogVisible = true;
      this.url = "/logistics/change";
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/logistics/delete?id=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less">
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
